export const environment = {
  production: true,
  BASE_DOMAIN:'https://fms.apollosupplychain.com/',
  AUTH_URL:'https://auth.apollosupplychain.com/auth-service-common/',
  New_BASE_DOMAIN:'https://fms.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://fms.apollosupplychain.com/',
  WebsocketUrl: 'wss://fms.apollosupplychain.com/websocket-service/ws/notifications'
};
